//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

import { Api, LocalDictionaryFactory } from './../api/api.module'

import { LoggerService } from './../common/common.module'
import { i18n } from '../common/i18n/common.i18n'

import { IUserSession, CommonHelper, EventsNames, LocalizationHelper } from '../../helpers'

import { Enums, Activity } from '../../models/common'
import { OpSimCard } from '../../models/core'
import { SESSION } from '../../models/custom'

import { BaseGridController, ScopeBaseGrid } from '../common/common.base.grid.controller'
import { CreateEditInitParams, BulkEditInitParams } from '../common/create-edit-popup/create-edit-popup.controller'
import { GridTypes, GridController } from '../common/grid/grid.controller'
import { ButtonsOptions } from '../common/grid/grid.controller'
import { ImportOptions } from '../common/import/import.directive'
import { ExportOptions } from '../common/export/export.directive.controller'
import { DetailsOptions } from '../common/details-popup/details-popup.directive'
import { SystemService } from '../../services/system'

interface SimcardsScope extends ScopeBaseGrid { }

export class SimcardsController extends BaseGridController {

    // Members

    private grid: GridController<OpSimCard>

    // Members End


    // Ctor

    constructor(
        protected $scope: SimcardsScope,
        protected $state: StateService,
        $timeout: ng.ITimeoutService,
        protected api: Api,
        private logger: LoggerService,
        protected localDictionary: LocalDictionaryFactory,
        protected userSession: IUserSession,
        protected systemService: SystemService,
        referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $state, userSession, systemService, api, localDictionary, CommonHelper.IdSimCard, referenceType)//TO DO!!! do usunięcia parametr type CommonHelper.IdSimCad

        this.setEvents()
        this.setMainGridOptions()
    }

    // Ctor End


    // Events

    public onInitialized(e: any, grid: GridController<OpSimCard>) {
        this.setGridId(e.tableId)
        this.dataGrid = e.component
        this.grid = grid
    }

    public onAdd() {
        const createEditInitParams: CreateEditInitParams =
        {
            moduleName: Enums.SimaxModuleName.Sim_Card,
            idReferenceType: this.referenceType,
            createEditSelectedTabType: Enums.SimaxCreateEditSelectedTabType.BaseParameters,
            groupReferenceType: null,
            groupReferenceValue: null,
            referenceObjectId: 0,
            referenceObject: null,
            sections: null,
            useBusinessObjects: true
        }

        this.$scope.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createEditInitParams)
    }

    public onEdit() {
        if (this.dataGrid.getSelectedRowKeys().length == 1) {
            const createEditInitParams: CreateEditInitParams = {
                moduleName: Enums.SimaxModuleName.Sim_Card,
                idReferenceType: this.referenceType,
                createEditSelectedTabType: Enums.SimaxCreateEditSelectedTabType.BaseParameters,
                groupReferenceType: null,
                groupReferenceValue: null,
                referenceObjectId: this.dataGrid.getSelectedRowsData()[0][CommonHelper.idField],
                referenceObject: null,
                sections: null,
                useBusinessObjects: true
            }

            this.$scope.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createEditInitParams)
        }
        else {
            var columnCount = this.dataGrid.columnCount()
            var columns = []

            for (var i = 0; i < columnCount; i++) {
                columns.push(this.dataGrid.columnOption(i));
            }
            var gridData = angular.copy(this.dataGrid.getSelectedRowsData())

            var bulkEditInitParams: BulkEditInitParams =
            {
                moduleName: Enums.SimaxModuleName.Sim_Card,
                idReferenceType: this.referenceType,
                groupReferenceType: null,
                groupReferenceValue: null,
                selectedGridRows: gridData,
                gridColumns: columns,
                section: null,
                columnsReorderingDisabled: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.SimCardModuleMainGrid, false),
                useBusinessObjects: true
            }
            this.$scope.$root.$broadcast(EventsNames.INITIALIZE_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    public onShowDetails(e: any) {
        const detailsOptions: DetailsOptions = {
            hasPermission: true,
            idReferenceType: this.referenceType,
            moduleName: this.moduleName,
            pageItemsIds: this.grid.pageItemsIds,
            referenceObjectId: this.grid.selectedItemId,
        }

        this.showDetails(e, detailsOptions)
    }

    public onDelete() {
        this.$scope.needConfirmDelete = true
        this.$timeout(() => {
            this.$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.popupId, i18n('Popup', 'ConfirmDeleteSimcard'))
        })
    }

    public onDeleted() {
        this.dataGrid.refresh()
    }

    public onConfirmDelete() {
        var toDelete: OpSimCard = new OpSimCard(null)
        toDelete.idSimCard = this.dataGrid.getSelectedRowsData()[0][CommonHelper.idField]
        this.userSession.getDataProvider().SimCard.deleteSimCard(toDelete).then(result => {
            this.$scope.$root.$broadcast(EventsNames.SIM_CARD_DELETED)
            CommonHelper.openInfoPopup(i18n('Popup', 'SimcardDeleted'))
        }).fail(err => {
            var errorMsg: string = err
            if (SESSION.isType(err)) {
                errorMsg = (<SESSION>err).toString()
                CommonHelper.openInfoPopup(errorMsg, 'error', 4000)
            } else
                CommonHelper.openInfoPopup(i18n('Popup', 'SimcardDeleteError'), 'error', 4000)
            //this.logger.log(err)
        })
    }

    // Events End


    getContextMenuItems(isTouchScreen: boolean = false): JQueryPromise<any[]> {
        return this.getItems(isTouchScreen)
    }
    getGridButtonsOptions(): ButtonsOptions {
        return {
            enabled: true,
            showDetailsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.SIM_CARD_LIST) ? "['" + Activity[Activity.SIM_CARD_LIST] + "']" : null,
            deletePermissions: this.userSession.getLoggedOperator().hasPermission(Activity.SIM_CARD_DEL) ? "['" + Activity[Activity.SIM_CARD_DEL] + "']" : null,
            editPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.SIM_CARD_EDIT) ? "['" + Activity[Activity.SIM_CARD_EDIT] + "']" : null,
            addPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.SIM_CARD_ADD) ? "['" + Activity[Activity.SIM_CARD_ADD] + "']" : null,
            importPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.SIM_CARD_IMPORT_OP) ? "['" + Activity[Activity.SIM_CARD_IMPORT_OP] + "']" : null,
            exportPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.SIM_CARD_EXPORT_OP) ? "['" + Activity[Activity.SIM_CARD_EXPORT_OP] + "']" : null,
            saveColumnSettingsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP) ? "['" + Activity[Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP] + "']" : null,

            onShowClick: () => { this.$scope.showDetails({ data: this.dataGrid.getSelectedRowsData()[0] }) },
            onAddClick: () => { this.onAdd() },
            onEditClick: () => { this.onEdit() },
            onDeleteClick: () => { this.onDelete() }
        }
    }
    getImportOptions(): ImportOptions {
        return {
            dictionaryMethodName: 'getSimcardImportParams',
            popupName: i18n('Popup', 'ImportSimcards'),
            requestMethodType: 'simcard',
            referenceType: this.referenceType,
            moduleName: this.moduleName,
            columnsReorderingDisabled: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP, Enums.UIObjectProperties.SimCardModuleMainGrid)
        }
    }

    getExportOptions(): ExportOptions {
        return {
            referenceType: Enums.ReferenceType.IdSimCard,
            pluginOptions: {
                moduleName: Enums.SimaxModuleName.Sim_Card,
                popupName: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EXPORT, Enums.SimaxModuleName.Sim_Card),
            },
        }
    }

    setEvents() {
        this.$scope.$on(EventsNames.SIM_CARD_DELETED, (event: ng.IAngularEvent, ...args: any[]) => { this.onDeleted() })
        this.$scope.showDetails = (e) => { this.onShowDetails(e) }
        this.$scope.confirmDelete = () => { this.onConfirmDelete() }
    }
    setMainGridOptions() {
        this.userSession.getDataProvider().System.getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS, Enums.SimaxModuleName.Sim_Card).then(columns => {
            this.userSession.getDataProvider().System.getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEFAULT_GRID_PARAMS, Enums.SimaxModuleName.Sim_Card).then(defaultColumns => {
                this.$scope.mainGridOptions = {
                    referenceId: this.referenceType,
                    idReferenceType: this.referenceType,
                    type: GridTypes.MAIN,
                    name: 'SimCardsGrid',
                    defaultColumnsDictionary: defaultColumns,
                    columnsDictionary: columns,
                    addCustomFilters: true,
                    preExecuteClearFilter: this.preExecuteGridClearFilter,
                    allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.SimCardModuleMainGrid),
                    importOptions: this.getImportOptions(),
                    exportOptions: this.getExportOptions(),
                    onInitialized: (e: any, grid: GridController<OpSimCard>) => this.onInitialized(e, grid),
                    onDataReady: data => { this.onDataReady(data) },
                    onRowDoubleClick: e => { this.onShowDetails(e) },
                    contextMenuItems: (isTouchScreen: boolean = false) => { return this.getContextMenuItems(isTouchScreen) },
                    buttonsOptions: this.getGridButtonsOptions(),
                    localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.simcardSaved,
                    getDataSourceMethod: this.userSession.getDataProvider().SimCard.getSimCardFilter,
                    dataSourceAdditionalFields: null
                }
            })
        })
    }
}

